import React from 'react';
import { Transition } from 'react-transition-group';
import { cn } from '@/lib/utils';

import { useAuth } from '@/lib/auth-provider';

interface TopModalProps {
  isOpened: boolean;
  setIsOpen: (value: boolean) => void;
  setIsAwake: (value: boolean) => void;
  resetChat: () => void;
  showPopover: () => void;
}

function Modal({ isOpened, setIsOpen, setIsAwake, resetChat }: TopModalProps) {
  const { logout } = useAuth();

  const goToWebsite = () => {
    window.open('https://www.proxiaistudio.com', '_blank');
    setIsOpen(false);
  };

  const endInterview = () => {
    setIsOpen(false);
    setIsAwake(false);
    // Navigate to the base URL to show the interviews list
    // Don't call resetChat as it reloads the page and may cause auth issues
    window.location.href = '/';
  };

  const signOut = () =>  {
    logout();
    setIsAwake(false);
  };

  return (
    <Transition in={isOpened} timeout={300}>
      {(state) => (
        <>
          <div 
            className={cn(
              "bg-black/20 w-screen h-screen z-[9998] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300 ease-in-out",
              isOpened ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
            )}
            onClick={() => setIsOpen(false)} 
          />
          <div 
            className={cn(
              "fixed top-0 z-[9999] w-full flex items-center justify-center transition-transform duration-300 ease-in-out",
              (state === 'entering' || state === 'entered') ? "translate-y-0 pointer-events-auto" : "-translate-y-full pointer-events-none"
            )}
          >
            <div className="max-w-[400px] h-auto p-6 flex-grow-0 flex-shrink-0 text-white z-[9999] rounded-lg max-[600px]:w-[90vw]" style={{ backgroundColor: '#3D3D3D' }}>
              <div className="flex flex-col justify-around items-start space-y-4">
                <button 
                  className="cursor-pointer font-sans font-medium py-3 px-4 rounded border border-white flex text-[16px] leading-[20px] text-white bg-transparent hover:bg-white hover:text-black transition-all duration-500 ease-in-out w-full justify-start tracking-wider focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
                  onClick={goToWebsite}
                >
                  ABOUT PROXI
                </button>
                <button 
                  className="cursor-pointer font-sans font-medium py-3 px-4 rounded border border-white flex text-[16px] leading-[20px] text-white bg-transparent hover:bg-white hover:text-black transition-all duration-500 ease-in-out w-full justify-start tracking-wider focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
                  onClick={endInterview}
                >
                  END INTERVIEW
                </button>
                <button
                  className="cursor-pointer font-sans font-medium py-3 px-4 rounded border border-white flex text-[16px] leading-[20px] bg-white text-[#3D3D3D] hover:bg-white hover:text-black transition-all duration-500 ease-in-out w-full justify-start tracking-wider focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
                  onClick={() => setIsOpen(false)}
                >
                  CONTINUE INTERVIEW
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Transition>
  );
}

export default Modal;
